import { Edge, Node } from '@xyflow/react';
import { GlobalSettingsType } from 'src/context/global/types';
import {
  ELinkMdi,
  ELinkSpeed,
  ELinkDuplex,
  IEdgeExtraData,
} from 'src/modules/network-configuration/edges/types';
import { NodeCategoryModel } from 'src/modules/network-configuration/models/node-data';
import {
  IConfigurationInterface,
  IConfigurationInterfaceItem,
} from 'src/types/configuration';

import { getInfoConnected } from '../node';

export const configurationInterface = ({
  nodeId,
  nodeCategory,
  edges,
  nodes,
  globalSettings,
}: {
  nodeId: string;
  nodeCategory: NodeCategoryModel;
  edges: Edge[];
  nodes: Node[];
  globalSettings?: GlobalSettingsType;
}): IConfigurationInterface => {
  const defaultInterface: IConfigurationInterface = {
    bsp: false,
    interfaces: [],
    version: 1,
  };

  const interfaceItem: IConfigurationInterfaceItem[] = [];
  if (!nodeCategory.ports) return defaultInterface;

  nodeCategory.ports.forEach((port) => {
    const { node, edge } = getInfoConnected(nodeId, port.id, edges, nodes);
    const { portIndexes } = nodeCategory;
    const portIndex = portIndexes[port.id] || 0;
    if (!portIndex) {
      throw new Error('Port index not found');
    }

    const edgeData = edge?.data as IEdgeExtraData;
    const isUnused = !node || !edge;

    const name = edgeData?.useCustomDescription
      ? edgeData?.customDescription || ''
      : (node?.data?.category as NodeCategoryModel)?.name || '';

    let duplex = true;
    if (edgeData?.linkDuplex && edgeData.linkDuplex === ELinkDuplex.HALF) {
      duplex = false;
    }

    let speed = 100;
    if (edgeData?.linkSpeed && edgeData.linkSpeed !== ELinkSpeed.AUTO) {
      speed = parseInt(edgeData.linkSpeed, 10);
    }

    // For unused ports, use global settings; for connected ports, use edge data
    const up = isUnused
      ? (globalSettings?.unusedPorts?.interface ?? false)
      : (edgeData?.enableLink ?? false);

    const interfaceItemData = {
      autoneg: edgeData?.autoNegotiation ?? true,
      diagnostics: edgeData?.enableMonitoring ?? false,
      duplex,
      interface: portIndex,
      mdi: edgeData?.linkMdi ?? ELinkMdi.AUTO,
      name,
      speed,
      up,
    };

    interfaceItem.push(interfaceItemData);
  });

  defaultInterface.interfaces = interfaceItem.sort(
    (a, b) => a.interface - b.interface,
  );

  return defaultInterface;
};
